<template>
  <div>
    <div class="search-header">
      <div class="box-title">我的诉求</div>
      <el-input v-model="dataForm.quesDes__quesContent" style="width: 400px" placeholder="请输入">
        <el-button slot="append" icon="el-icon-search" type="primary" @clcik="getServiceList">查询</el-button>
      </el-input>
    </div>
    <div class="filter-item">
      处理状态：<span
        v-for="item in statuss"
        :key="item.cd"
        class="item-type"
        :class="[dataForm.status === item.cd ? 'active' : '']"
        @click="selectType(item)"
        >{{ item.nm }}</span
      >
    </div>
    <div v-for="item in list" :key="item.id" class="ans-box">
      <div class="ans-box-item">
        <div class="ans-box-title"><img :src="require('@/assets/images/问.png')" alt="" />{{ item.quesDes }}</div>
        <div class="ans-box-time">{{ item.quesTime }}</div>
      </div>
      <div class="ans-box-content">
        <img :src="require('@/assets/images/答.png')" alt="" />
        <expendBox :text="item.resContent || '暂无解答'" />
      </div>
      <div style="text-align: right">
        <el-button type="text" size="small" @click="del(item)">删除</el-button>
      </div>
    </div>
    <div v-if="list.length === 0" class="no-msg">暂无数据</div>
    <el-pagination
      v-if="list.length"
      layout="prev, pager, next"
      :current-page="page.pageNo"
      :page-size="page.pageSize"
      :background="true"
      :total="total"
      @current-change="currentChangeHandle"
    />
  </div>
</template>

<script>
import expendBox from '@/components/expendBox'
export default {
  components: {
    expendBox,
  },
  data() {
    return {
      total: 0,
      page: {
        pageNo: 1,
        pageSize: 5,
      },
      dataForm: {
        status: '',
      },
      statuss: [],
      list: [],
    }
  },
  mounted() {
    this.getServiceList()
    this.getEnum('ZzmhPersonQuesEn$Status', 'statuss')
  },
  methods: {
    del(item) {
      this.$confirm('确定删除此诉求?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.$http({ method: 'get', url: '/zzmh/in/personQues/del?id=' + item.id }).then((res) => {
          this.$message({
            type: 'success',
            message: '操作成功!',
          })
          this.getServiceList()
        })
      })
    },
    getEnum(code, key) {
      this.$http({ method: 'get', url: `/general/enum/list?cls=${code}` }).then((res) => {
        this[key] = [{ cd: '', nm: '全部' }, ...res.data.list]
      })
    },
    gotoAdd() {
      this.$router.push({
        path: '/service/add',
      })
    },
    handleSizeChange(val) {
      this.page.pageNo = 1
      this.page.pageSize = val
      this.getServiceList()
    },
    currentChangeHandle(val) {
      this.page.pageNo = val
      this.getServiceList()
    },
    selectType(item) {
      this.dataForm.status = item.cd
      this.getServiceList()
    },
    getServiceList() {
      let query = this.$query.new()
      this.$query.toF(query, this.dataForm)
      this.$query.toP(query, this.page.pageNo, this.page.pageSize)
      let params = {}
      this.$http({ method: 'get', url: '/zzmh/in/personQues/page?query=' + encodeURIComponent(this.$query.toJsonStr(query)), params }).then((res) => {
        console.log(res)
        this.list = res.data.list
        this.total = res.page.total
      })
    },
  },
}
</script>

<style lang="less" scoped>
@media screen {
  .no-msg {
    margin: 50px 0;
    text-align: center;
  }
  .service-page {
    display: flex;
    margin-top: 30px;
    color: #333333;
    .box {
      background: #ffffff;
      box-shadow: 0px 2px 9px 0px rgba(235, 236, 244, 1);
      border-radius: 10px;
      padding: 16px 24px;
      font-family: PingFangSC-Regular;
      font-size: 20px;
      color: #333333;
      letter-spacing: 0;
      font-weight: 400;
      margin-bottom: 12px;
      .box-title {
        font-family: PingFangSC-Semibold;
        font-size: 18px;
        color: #333333;
        letter-spacing: 0;
        font-weight: 600;
      }
    }
    .right {
      flex: 1;
      .search-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 16px;
      }
      .filter-item {
        font-size: 16px;
        padding-bottom: 20px;
        border-bottom: 2px solid #f6f7fb;
      }
      .ans-box {
        margin-top: 20px;
        border-bottom: 2px solid #f6f7fb;
        padding-bottom: 20px;
        .ans-box-content {
          display: flex;
          font-size: 16px;
          color: #666666;
          img {
            width: 16px;
            height: 16px;
            margin-right: 8px;
            margin-top: 3px;
          }
        }
        .ans-box-item {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 8px;
          .ans-box-title {
            flex: 1;
            font-family: PingFangSC-Medium;
            font-size: 16px;
            color: #333333;
            display: flex;
            align-items: center;
            letter-spacing: 0;
            font-weight: 500;
            img {
              width: 16px;
              height: 16px;
              margin-right: 8px;
              // margin-top: 7px;
            }
          }
          .ans-box-time {
            width: 150px;
            font-family: PingFangSC-Regular;
            font-size: 14px;
            color: #666666;
            letter-spacing: 0;
            text-align: right;
            font-weight: 400;
          }
        }
      }
      .item-type {
        font-family: PingFangSC-Regular;
        font-size: 16px;
        color: #666666;
        letter-spacing: 0;
        text-align: center;
        font-weight: 400;
        margin-right: 16px;
        cursor: pointer;
        &.active {
          color: #1b5bfa;
          font-family: PingFangSC-Semibold;
        }
      }
    }
    .left {
      width: 280px;
      margin-right: 20px;
      .add-card {
        display: flex;
        align-items: center;
        justify-content: space-between;
        img {
          width: 60px;
        }
      }
      .mine-card {
        .mine-item {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: 12px;
          img {
            width: 48px;
            border-radius: 7.2px;
          }
          .mine-type {
            font-family: PingFangSC-Regular;
            font-size: 16px;
            color: #666666;
            letter-spacing: 0;
            text-align: center;
            font-weight: 400;
          }
          .mine-num {
            font-family: YouSheBiaoTiYuan;
            font-size: 20px;
            color: #666666;
            letter-spacing: 0;
            text-align: right;
            font-weight: 400;
            width: 50px;
          }
        }
      }
    }
  }
  @media (min-width: 769px) {
  }

  @media (max-width: 768px) {
  }
}
</style>
